<ftl-quote-header></ftl-quote-header>
<ftl-quote-home></ftl-quote-home>
<ftl-quote-footer></ftl-quote-footer>
